<template>
  <div class="sph-protocol">
    <div class="sph-protocol-header">
      <h2>
        USER PRIVACY
      </h2>
      <h2>
        AGREEMENT
      </h2>
      <h3>
        用户隐私协议
      </h3>
    </div>
    <div class="sph-protocol-content">
      <p>
        公司（以下简称 “公司”或“我们”）是在中国注册并存续的有限责任公司，我们尊重您的个人信息权利并且深知遵循合法、正当、必要和诚信原则处理您的个人信息的重要性。本网站（圆和健康）系我们运营的官方网站。本《隐私声明》（以下简称“声明”）旨在向您介绍本网站处理您的个人信息的目的、方式和范围，以及您如何行使您享有的基于个人信息保护的权利。
      </p>
      <p>
        本声明适用于本网站所提供的各项功能和服务。此外，本网站中可能存在部分功能或者服务由我们的关联公司、第三方合作伙伴提供，这些功能或者服务将适用单独的服务协议或者隐私政策，并将在您使用这些功能或者服务前单独向您告知。
      </p>
      <p>
        请您在开始使用本网站前，仔细阅读并确保您已经完全理解本声明；如果您不同意本声明的全部内容，请不要进行后续操作并提供您的任何个人信息。
      </p>
      <p>
        本隐私声明将帮助您了解以下内容：
        一、 定义
        二、 我们如何收集、使用您的个人信息
        三、 我们如何对外提供、委托处理、公开披露、转移您的个人信息
        四、 我们如何存储和保护您的个人信息
        五、 我们如何保护未成年人的个人信息
        六、 如何管理您的个人信息
        七、 我们如何使用COOKIE和同类技术
        八、 本隐私声明如何更新
        九、 如何与我们联系
      </p>
      <p>
        一、定义
        本声明中的以下名词的具体含义为：
        “个人信息”：以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
        “敏感个人信息”：一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
        “处理”：包括个人信息的收集、存储、使用、加工、传输、提供、公开、删除等。
        “集团”：指上海新太永康健康科技有限公司及其附属公司，包括但不限于上海新永门诊部有限公司，以及上海新太门诊部有限公司。

        本声明中出现以上未定义的相关名词含义，除由特殊说明外，与中华人民共和国个人信息保护相关法律法规的含义保持一致。
      </p>
      <p>
        二、我们如何收集、使用您的个人信息
        我们可能会出于本声明所述的以下目的，收集和使用您在使用我们产品或服务过程中主动提供、或因使用产品或服务而产生的个人信息，以及根据法律法规规定或您的授权同意合法向第三方收集的个人信息。如果我们需要额外收集您的个人信息，我们将以合理的方式向您告知并在收集前征得您的同意。若您通过本网页为其他人投保保险产品、申请理赔或申请预约就诊的，在您向我们提供该实际被保险人的个人信息之前，您需确保您已经取得其授权同意。
        若我们需将您的个人信息用于本声明未载明的其他用途，会按照法律法规及国家标准的要求向您充分告知信息收集和使用的目的、方式和涉及的个人信息种类，再次征求您的同意。若我们需将基于特定目的收集而来的您的个人信息用于其他目的时，也会事先征求您的同意。在您关闭或停止使用该业务功能后，我们将会停止收集您个人信息的行为。
      </p>
      <p>
        （一）我们收集的个人信息包括：
        身份信息——姓名、地址、个人联系方式（包括电子邮箱和电话号码等其他联系信息）、出生日期、护照号码、身份证件号码、个人生物识别信息、您孩子的相关信息，以及健康记录；
        金融信息——银行账户或信用卡信息、鉴别信息、金融交易信息、财产信息、借贷信息及其他反映特定个人某些情况的信息；
        技术信息——IP地址、浏览器类型和版本、时区设置、浏览器插件类型、操作系统和平台、设备信息（包括无线网络和一般网络信息）。
        请您注意，您的个人生物识别信息、健康记录、金融信息，以及您14岁以下孩子的相关信息属于敏感个人信息，即一旦泄露或者非法使用，容易导致您或您受抚养者的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。以上敏感个人信息均为我们提供相应服务的必要个人信息，且我们只会为了上述目的处理相应的敏感个人信息。如果您不提供您的个人生物识别信息、健康记录、金融信息，我们将无法为您提供与您保单相关的服务。如果您不提供您14岁以下孩子的相关信息，我们将无法为您14岁以下孩子提供相关保险服务。
      </p>
      <p>
        （二）我们会基于如下目的使用您的个人信息：
        向您提供查阅本网站内容的权限；
        处理、管理、实施和生效您不时向我们提交的任何文件中的请求或交易；
        管理您的保单；向您收取保费和其中未支付的部分；调查、分析、处理和支付您的保单项下提出的理赔；以及办理您的保单的续期、变更、取消或再保险事宜；
        行使在您的保单项下的任何权利，包括代位求偿权（如适用）；
        设计我们拟提供的新产品、信息和服务，或者改善我们所提供的现有产品、信息和服务；
        与您进行沟通，包括向您发送与您已在 购买的保单或注册的账户有关的事务性或其他沟通，以及提供关于 网站的技术支持，或者向您发送关于本隐私声明未来变更的沟通函；
        用于集团、金融服务业或相关监管机构开展的统计或精算研究；
        用于医疗的高级技术分析、数据匹配、内部业务（包括企业重组）和管理目的；
        对您使用本网站的行为进行监控和分析，以便实施本网站或服务的运行、评估和改进工作，并且了解您的偏好和解决任何问题；
        在任何司法管辖区的司法机关、其他政府机关或监管机构开展的执法活动和调查中提供协助，以及满足法律法规规定的要求，或者履行其他向司法机关、政府机关或监管机构承诺的义务；
        对网站的外观进行个性化设置，提供相关产品、信息和服务的建议，以及在网站上或通过其他渠道提供定向广告；
        在收集您个人信息时告知的其他目的；以及与以上任何内容直接相关的其他目的。
      </p>
      <p>
        除上述目的之外，我们还可能会将您的姓名及联系信息用于市场营销的目的，包括向您发送以下产品和服务的市场营销材料：保险、年金、财富管理、投资、银行、金融服务、医疗/保健治疗、奖励/会员奖励/优惠计划。如果您不希望接收市场营销材料，您可以按照以下方式退出，且退出市场营销功能不影响您使用本网页的其他功能。
        此外，在您使用本网站浏览、搜索，以及接受我们提供的各项服务时，我们将会收集您的您的浏览信息和行为数据，并基于这些数据及您的个人信息进行综合分析向您推荐您可能感兴趣的内容、活动通知以及产品信息或广告。如您不希望我们为您推荐个性化商品/服务，您可以按照如下方式进行退出，且退出个性化推荐功能不影响您使用本网页的其他功能，退出后我们仅会在相关页面为您展示一般排序的热门内容，而不会结合您的偏好向您进行推荐。
        您可以发送书面通知至如下地址或向以下电子邮件地址发送您的退出通知：
        上海市茂名南路205号12F圆和医疗
        邮编： 200020
        电子邮件：
      </p>
      <p>
        根据相关法律法规，以下情形中，我们可能会收集、使用您的相关个人信息而无需征求您的授权同意：
        涉及国家安全与利益、社会公共利益的；
        为履行我们的法定职责或者法定义务所必需有关的；
        与您签订和履行您作为合同一方所必需的；
        为应对突发公共卫生事件，或者紧急情况下为保护您的生命健康和财产安全所必需；
        在合理的范围内处理您自行向社会公众公开的个人信息；
        在合理的范围内处理从合法公开披露的信息中收集的您的个人信息（如合法的新闻报道、政府信息公开等渠道）；
        法律法规规定的其他情形。
      </p>
      <p>
        此外，请您知晓，若我们采用技术手段对个人信息进行处理，使得个人信息主体无法被识别且信息经处理后不能被复原，则此类处理后数据的使用无需另行向您通知并征得您的同意。
        请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告、另行签署协议等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。
      </p>
      <p>
        三、我们如何对外提供、委托处理、公开披露、转移您的个人信息
        我们会严加保密收集的个人信息，但在特定场景下，为了实现收集个人信息的目的，我们可能会在法律法规允许的范围向第三方提供或委托第三方处理您的个人信息。我们会要求接收方采取必要的数据安全保护措施以及承担相应的保密义务以保护您个人信息的安全。
      </p>
      <p>
        （一） 对外提供
        一般情况下，我们不会对外提供您的个人信息，但下列情况除外：
        1. 在获取单独同意下提供：获得您的单独同意后，我们会向我们的授权伙伴提供您授权范围内的信息。
        2. 在法定情形下提供：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外您的个人信息。
        3. 经您单独同意后向“集团”内的关联公司提供：出于公司管理的需要，您的信息可能会向“集团”内的关联公司提供。我们只会提供必要的个人信息，且受本声明所述目的的约束。
        向关联公司提供的个人信息可能包括但不限于上述您的身份信息、金融信息，以及技术信息（详见“二、我们如何收集、使用您的个人信息”）。为确保您个人信息的安全，集团对上述信息负有保密义务，并尽最大努力采取各种措施保证信息安全。
        4. 经您单独同意后向我们的授权合作伙伴提供：仅为实现本声明所述的目的，我们的某些服务将由授权合作伙伴提供。我们可能会向合作伙伴提供您的某些个人信息，以提供相应的客户服务和用户体验。具体包括：
        为了更好地为您提供相关营销推广服务，我们会根据约定将您的个人信息提供给市场营销服务提供商（无论是在集团之内还是之外）、呼叫中心、营销研究服务公司，以便他们能够就其提供的产品和服务向您发送相关市场营销资料。
      <table
        border="1"
        cellspacing="0"
      >
        <thead>
          <tr>
            <td>
              序号
            </td>
            <td>
              接收方信息
            </td>
            <td>
              个人信息类型
            </td>
            <td>
              对外提供目的
            </td>
            <td>
              对外提供方式
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              1
            </td>
            <td>
              名称：
              联系方式：
            </td>
            <td>
              姓名、性别、身份证号码
            </td>
            <td>

            </td>
            <td>

            </td>
          </tr>
        </tbody>

      </table>
      </p>
      <p>
        （二）委托处理
        我们不时会向我们委托的服务提供商传输您的个人信息，以便提供相应的产品和服务。我们会要求服务提供商仅在约定的范围内处理您的个人信息，采取必要的数据安全保护措施以及承担相应的保密义务以保护您个人信息的安全，并对其个人信息处理行为进行定期审计或者监督。具体而言，我们可能委托以下服务提供商处理您的个人信息：
        已获授权成为 营销员且与代理销售 提供之产品和服务有关的人士；
        任何提供与 业务营运和向您提供 服务有关的管理、数据处理、电信、计算机、支付、债务催收或证券结算、技术外包、云端、呼叫中心、邮寄和印刷服务的代理、承包商或第三方服务提供商（无论是 集团之内还是之外）；
        代理机构、合同工或第三方服务提供商（无论是 集团之内还是之外），包括协助 提供服务的公司，比如再保险公司、投资管理公司、理赔调查公司、行业协会或联合会；以及
        为了改进我们向您提供的服务，而帮助 收集您的信息或与您进行沟通的其他公司，比如研究公司及评级机构。
      </p>
      <p>
        （三）公开披露
        我们将遵守相关法律法规，对您的个人信息予以保密。除非事先获得您的单独同意或授权或依照法律规定所必需，我们不会公开披露您的个人信息，但以下情形除外：
        获得您明确、单独同意后；
        基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
        为了维护自己合法权益而向您提起诉讼或者仲裁时。
      </p>
      <p>
        （四）转移
        在涉及合并、收购或破产清算时，如涉及到个人信息转移，我们会向个人告知接收方的名称或者姓名和联系方式，并要求接受您个人信息的公司、组织继续受此隐私声明的约束，履行相关个人信息保护义务。否则，我们将要求该公司、组织重新取得您的同意。当我们作为接收方时，我们会按照您原公司、组织的个人信息处理规则处理您的个人信息，如果我们变更原先的处理目的、处理方式时，我们重新取得您的同意
        根据相关法律法规，以下情形中，我们可能会对外提供、委托处理、公开披露、转移您的相关个人信息而无需征求您的授权同意：
        涉及国家安全与利益、社会公共利益的；
        为履行我们的法定职责或者法定义务所必需有关的；
        与您签订和履行您作为合同一方所必需的；
        为应对突发公共卫生事件，或者紧急情况下为保护您的生命健康和财产安全所必需；
        在合理的范围内处理您自行向社会公众公开的个人信息；
        在合理的范围内处理从合法公开披露的信息中收集的您的个人信息（如合法的新闻报道、政府信息公开等渠道）；
        法律法规规定的其他情形。
      </p>
      <p>
        四、我们如何存储和保护您的个人信息
        （一）您的个人信息是如何在全球范围内提供的
        原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内，但由于我们通过遍布全球的资源和服务器提供产品或服务，在获得您的单独同意后，您的个人信息可能会提供至位于中华人民共和国以外司法辖区的关联公司、合作伙伴或第三方服务提供商，或者受到来自这些司法辖区的访问。该等跨境提供的主要目的包括：基于创建您的账号和完善身份验证的目的或基于提供 保险服务的目的。
        此外， 集团可能会因如下原因必须向中华人民共和国之外司法辖区的司法或执法机构提供您的个人信息：（a）按照适用于 集团的司法管辖区或任何其他司法管辖区的法律和/或监管义务；或（b）按照 集团与相关政府机关、监管机构或其他人士签订的协议。
        此类管辖区可能设有不同的数据保护法律，在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境提供个人信息的单独同意，或者在跨境数据转移之前实施数据去标识化等安全举措。我们将根据法律、法规和相关监管要求进行个人信息保护影响评估，并且完成通过国家网信部门组织的跨境传输安全评估、进行个人信息保护认证，或按照国家网信部门制定的标准合同与境外接收方订立合同，约定我们与境外接收方的权利和义务。涉及向境外司法或执法机构提供您的个人信息前，我们会根据法律法规的要求，获得中华人民共和国主管机关的同意。
        如您需要向境外接收方行使关于您个人信息保护的权利，您可以通过以下方式联系我们，我们将为您提供帮助，一般情况下，我们将15个工作日内回复：
        电子邮件：
      </p>
      <p>
        （二）您的个人信息是如何存储和保护的
        仅会在实现收集您个人信息的目的最短必要期间内保留您的个人信息，除非为了遵守相关法律法规及监管规定关于信息留存的要求，包括按照《保险法》《网络安全法》《电子商务法》《保险销售行为可回溯管理暂行办法》等规定的法定期限进行保存。当您删除个人信息或账号注销后，我们将对您的个人信息进行立即删除或匿名化处理。
        我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、泄露、篡改或丢失。我们会采取合理可行的措施，保护您的个人信息。例如，在传输数据时采用SSL加密；我们同时对本网页提供https安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        但同时请您注意，互联网并非绝对安全的环境，而且电子邮件、即时通讯等与其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的信息安全。
      </p>
      <p>
        五、我们如何保护未成年人的个人信息
        在互联网保险活动中我们推定您具有相应的民事行为能力。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您父母或法定监护人的同意。
        特别地，若您是14周岁以下的儿童，儿童及其监护人在为儿童使用我们的产品或服务前，还应仔细阅读我们还专门制定的《儿童个人信息保护政策》。只有在取得监护人对《儿童个人信息保护政策》的同意后，您才可在监护人的指导下使用我们的产品和服务。如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了儿童个人信息，我们会设法尽快删除相关数据。
        若您是儿童的父母或其他监护人，请您关注儿童是否是在取得您的授权同意之后使用我们的产品或服务。如您对儿童个人信息有疑问，请通过“九、如何与我们联系”中的联系方式与我们联系。
      </p>
      <p>
        六、您享有的个人信息权利
        （一）您享有的个人信息权利
        根据相关法律法规的规定，您有权：
        核实 是否持有任何关于您的个人信息；
        查询关于 如何使用您的个人信息，并要求获得您个人信息的副本；
        要求 更正任何与您有关的不准确的个人信息；
        限制或拒绝 对您个人信息的处理；
        要求在特定情况下删除您的个人信息；
        要求注销或删除您的注册账号（如有）；
        提出关于 数据处理行为的投诉；
        要求将您的个人信息转移至您指定的符合法律法规规定的其他个人信息处理者；以及
        咨询与个人信息有关的 政策及措施。
      </p>
      <p>
        在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。在进行自动化决策时，我们将确保决策的透明度和结果公平、公正，不会对您在交易价格等交易条件上实行不合理的差别待遇；在进行信息推送时，一并为您提供不针对个人特征的选项和拒绝方式（具体实现路径请参见“二、我们如何收集、使用您的个人信息”的个性化推荐部分）。如果您认为自动化决策结果显著影响了您的合法权益，您有权通过本声明提供的联系方式要求我们做出解释，并有权拒绝我们仅通过自动化决策的方式作出决定，我们也将提供适当的救济方式。
      </p>
      <p>
        （二）您如何行使您的权利
        您可以通过以下联系方式向我们行使您的上述权利：
        个人信息保护负责人
      </p>
      <p>
        上海市
        邮编：
        或发送电子邮件至：
      </p>
      <p>
        当您撤回同意后，我们无法继续为您提供撤回同意所对应的服务，也不再处理相应的个人信息。但您撤回同意的决定，不会影响此前基于您的同意而开展的个人信息处理。
      </p>
      <p>
        （三）我们如何响应您的请求
        一般情况下，我们将在十五个工作日内回复您的请求。对于您的合理请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，根据相关法律法规的规定， 有权对上述个人信息请求的处理收取直接相关和必要的费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
      </p>
      <p>
        在以下情形中，按照法律法规要求，我们将无法响应您的请求：
        与我们履行法律法规规定的义务相关的；
        与国家安全、国防安全直接相关的；
        与公共安全、公共卫生、重大公共利益直接相关的；
        与刑事侦查、起诉、审判和判决执行等直接相关的；
        有充分证据表明您或其他个人存在主观恶意或滥用权利的；
        出于维护您或其他个人的生命、财产等重大合法权益 但又很难得到本人授权同意的；
        响应您或其他个人的请求将导致您或其他个人、组织的合法权益受到严重损害的；以及
        涉及商业秘密的。
      </p>
      <p>
        七、COOKIE和同类技术的使用
        （一）COOKIE
        Cookie是包含少量信息的小型文本文件，并且被下载并保存在您的任何网页浏览器或上网设备（例如您的电脑、智能手机或平板电脑）中，而本网站的服务器随后可阅读其中的信息——类似网页的存储器。
        可能会在本网站上使用cookie等工具。如果您继续使用本网站，就表明您已同意我们将cookie用于您的电脑。我们可能会将所收集的信息（包括但不限于：您的IP地址（及域名）、浏览器软件、您的浏览器类型及配置、语言设置、地理位置、操作系统、推荐来源网站、所浏览的页面和内容、以及浏览时间）用于确保本网站的顺利运行，让您能够安全登录本网站，为了网页增强及优化目的而整理关于访问者如何到达和浏览 网站的汇总统计信息，以及帮助我们了解如何才能改善您的浏览体验。
        此外，cookie还可让本网站记住您及您的偏好，从而能够根据您的需要定制本网站的内容。营销性cookie让我们能够在 网站上提供尽可能与您有关的广告，例如，通过为您挑选基于兴趣的广告，或者避免持续地向您展示同一广告。您可以在 Cookie政策中了解关于我们所收集cookie的类型、我们使用cookie的目的、以及如何管理您的cookie设置的更多信息。
      </p>
      <p>
        （二）网站信标和像素标签
        除cookie外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
      </p>
      <p>
        （三）Do Not Track（请勿追踪）
        很多网络浏览器均设有Do Not Track功能，该功能可向网站发布Do Not Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了Do Not Track，那么我们的所有网站都会尊重您的选择。
      </p>
      <p>
        八、本隐私声明的修订
        为更好地提供服务，我们未来可能对本隐私声明进行变更或修改。如果该变更或修改造成您在隐私声明下权利的实质变化，我们会向您提供显著的通知并获得您的同意。您不同意该等经修订后的隐私声明的任何内容，您即应选择停止使用本服务。但如果更新的内容需要收集您的地理位置、联系方式、身份信息等敏感个人信息，我们仍会再次以显著方式征求您的单独同意。
        对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于短信、或在浏览页面做特别提示、弹窗提示等方式，说明隐私声明的具体变更内容）。
        本隐私声明所指的重大变更包括但不限于：
        我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式等；
        我们在公司结构、组织架构等方面发生重大变化，如业务调整、破产并购等引起的所有变更等；
        个人信息对外提供、转移或公开披露的主要对象发生变化；
        您参与个人信息处理方面的权利及其行使方式发生重大变化；
        我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时。
      </p>
      <p>
        九、如何与我们联系
        如果您对本隐私声明或相关事宜有任何疑问、意见或建议，您可以随时通过拨打我们的客服电话 或发送电子邮件至 等多种方式与我们联系。一般情况下，我们将在十五个工作日内予以回复。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "protocol",
};
</script>

<style lang="scss" scoped>
.sph-protocol {
  padding: 30px 20px;
  border-radius: 15px;
  height: 60vh;
  width: 80vw;
  color: #002d5d;
  box-sizing: border-box;
  h2 {
    font-family: Johnston100W03-Medium-Regular, Johnston100-W03-Medium;
    margin: 0;
    line-height: 26px;
    font-size: 26px;
    font-weight: 400;
  }
  h3 {
    font-size: 16px;
    font-weight: 500;
    color: #002d5d;
    line-height: 16px;
    margin: 10px 0 20px 0;
  }
  p {
    font-family: Johnston100W03-Medium-Regular, Johnston100-W03-Medium;

    margin: 10px 0;
    // text-indent: 28px;
    // white-space: break-spaces;
    color: #808c9b;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: justify;
  }
}
</style>